import { render } from "./MessagesView.vue?vue&type=template&id=a5e43e46&scoped=true"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"

import "./MessagesView.vue?vue&type=style&index=0&id=a5e43e46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a5e43e46"

export default script